export default {"src":"/_next/static/media/map-undraw.548f9aa6.svg","height":70,"width":87};